import Icons from '@/shared/components/icon/Icons'
import Toast from '@/shared/components/Toast'
import { Caption } from '@/shared/components/typography'

import { PARKINGLOT_TYPE } from '@/enums/detail'

interface SummaryInfoSectionViewProps {
  parkinglotType: PARKINGLOT_TYPE
  isCopySuccess: boolean
  setIsCopySuccess: React.Dispatch<React.SetStateAction<boolean>>
  isCopyFail: boolean
  setIsCopyFail: React.Dispatch<React.SetStateAction<boolean>>
  address: string
  operationTime: string
  calcPrice?: number
  copyAddress: () => Promise<void>
  isFullSheet?: boolean
}

const SummaryInfoSectionView = ({
  parkinglotType,
  isCopySuccess,
  setIsCopySuccess,
  isCopyFail,
  setIsCopyFail,
  address,
  operationTime,
  calcPrice,
  copyAddress,
  isFullSheet
}: SummaryInfoSectionViewProps) => {
  const isParkinglot = parkinglotType === PARKINGLOT_TYPE.PARKINGLOT
  return (
    <div className="flex flex-col gap-[8px] px-[16px]">
      <div className="flex items-center justify-between">
        <Caption level="caption1" weight="regular" color="text070">
          운영 시간
        </Caption>
        <Caption level="caption1" weight="regular" color={`${operationTime ? 'text090' : 'text050'}`}>
          {operationTime || '정보 없음'}
        </Caption>
      </div>
      <div className="flex items-center justify-between">
        <Caption level="caption1" weight="regular" color="text070">
          현장 요금
        </Caption>
        <Caption level="caption1" weight="regular" color={`${calcPrice ? 'text090' : 'text050'}`}>
          {calcPrice ? `1시간 기준 ${calcPrice.toLocaleString()}원` : '정보 없음'}
        </Caption>
      </div>
      {isFullSheet && (
        <div className="flex items-start justify-between">
          <Caption level="caption1" weight="regular" color="text070" className="shrink-0">
            주소
          </Caption>
          <div className="flex items-start">
            <Caption level="caption1" weight="regular" color="text090" className="break-words text-right">
              {isParkinglot ? address : address || <span className="text-text-050">지도에서 위치 확인</span>}
            </Caption>
            {address.length > 0 && (
              <div className="ml-[4px] cursor-pointer" onClick={copyAddress}>
                <Icons.CopyIcon stroke="currentColor" color="#6D7D90" />
              </div>
            )}
          </div>
          {isCopySuccess && (
            <Toast
              text="주차장 주소가 복사됐습니다."
              onClose={() => {
                setIsCopySuccess(false)
              }}
            />
          )}
          {isCopyFail && <Toast text="주소 복사에 실패했습니다." onClose={() => setIsCopyFail(false)} />}
        </div>
      )}
    </div>
  )
}

export default SummaryInfoSectionView
